module.exports = __webpack_public_path__ + "img/039.e6db4a75.png";